// extracted by mini-css-extract-plugin
module.exports = {"outer":"RelatedArticles_outer__ZKw0A","articles":"RelatedArticles_articles__QdBOS"};